/**
 * Leviathan Web - Financials Page
 * Quasar Prime LLC
 * Aggressive Tactical Industrial Design
 */

import { GeometricPanel } from '@components/ui/GeometricPanel';

const FinancialsPage = () => {
  return (
    <div className="space-y-6 relative">
      {/* Header with geometric frame */}
      <div className="relative">
        <div className="absolute -left-4 top-0 bottom-0 w-1 bg-gradient-to-b from-amber via-steel to-amber shadow-[0_0_8px_rgba(255,149,0,0.6)]" />
        <div className="border-l-4 border-amber pl-6">
          <h1
            className="text-4xl font-display font-bold text-steel tracking-wide uppercase"
            style={{ textShadow: '0 0 20px rgba(92, 140, 199, 0.6)' }}
          >
            Financials
          </h1>
          <p className="text-text-secondary text-sm mt-1 font-mono">Financial Management Interface</p>
        </div>
      </div>

      {/* Content Panel */}
      <GeometricPanel>
        <div className="flex items-center space-x-4 mb-6">
          <div className="w-2 h-12 bg-gradient-to-b from-amber via-steel to-amber" style={{ boxShadow: '0 0 8px rgba(255,149,0,0.6)' }} />
          <div>
            <h2 className="text-2xl font-display text-text-primary uppercase tracking-wide">Financial Control</h2>
            <p className="text-text-tertiary text-sm font-mono">Module under development</p>
          </div>
        </div>
        <div className="border-t border-panel-border pt-4">
          <p className="text-text-secondary font-mono text-sm">&gt; Initializing financial tracking system...</p>
          <p className="text-text-tertiary font-mono text-xs mt-2">
            Status: <span className="text-warning-amber" style={{ textShadow: '0 0 6px currentColor' }}>PENDING</span>
          </p>
        </div>
      </GeometricPanel>
    </div>
  );
};

export default FinancialsPage;
